export const Documents_Header_TXT = []
Documents_Header_TXT["en"] = "Documents"
Documents_Header_TXT["th"] = "เอกสารทั้งหมด"

export const Error_Download_TXT = []
Error_Download_TXT["en"] = "Have an error, unable to download !"
Error_Download_TXT["th"] = "เกิดข้อผิดพลาด ไม่สามารถดาวน์โหลดได้!"

